module.exports = "/_next/static/images/taz-ae300d6bc1c738d6bfd0cab40eab3e4c.png";